import { render, staticRenderFns } from "./NewClientService.vue?vue&type=template&id=608b2ed9&"
import script from "./NewClientService.vue?vue&type=script&lang=js&"
export * from "./NewClientService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('608b2ed9')) {
      api.createRecord('608b2ed9', component.options)
    } else {
      api.reload('608b2ed9', component.options)
    }
    module.hot.accept("./NewClientService.vue?vue&type=template&id=608b2ed9&", function () {
      api.rerender('608b2ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Components/NewClientService.vue"
export default component.exports